import { render, staticRenderFns } from "./TraxUiChartDonut.vue?vue&type=template&id=6a027b5f"
import script from "./TraxUiChartDonut.vue?vue&type=script&lang=js"
export * from "./TraxUiChartDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports